exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list {\n  width: 60%;\n  margin: 50px auto;\n  border: 1px solid #f7f7f7;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/news-list/news-list.component.less
// module id = ../../../../../src/app/news-list/news-list.component.less
// module chunks = main